import React from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import DisconnectImg from '../../../assets/icon/Disconnect.svg';
import closeicon from '../../../assets/icon/not-included.png';

const CampDisconnectModal = ({ showModal, setShowModal, handleDisconnect, username }) => {
    const closeModal = () => {
        setShowModal(false)
    }

    return (
        <Modal className='partner-unverified-modal' style={{ minHeight: "100%" }} show={showModal} centered onHide={closeModal}>
            <Modal.Header>
                <div class="close-button" onClick={closeModal}> <img src={closeicon} alt="" /></div>
            </Modal.Header>
            <Modal.Body>
                <div className='partner-unverified-inner'>
                    <div className='not-verified-image'>
                        <Image src={DisconnectImg} alt="disconnect" />
                    </div>
                    <h4>Disconnect</h4>
                    <p>Are you sure you would like to disconnect {username}?</p>
                    <div style={{ display: 'flex', paddingTop: '30px' }}>
                        <Button
                            className="load-button-container create-submit float-left new_button_account rounded-pill mb-4 font-weight-bold"
                            variant="light"
                            onClick={closeModal}
                            style={{ minWidth: '40%' }}
                        >
                            <span>No</span>
                        </Button>
                        <Button
                            className="load-button-container gred-btn create-submit float-left new_button_account rounded-pill mb-4 font-weight-bold"
                            onClick={handleDisconnect}
                            style={{ width: '40%' }}
                        >
                            <span>Yes</span>
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CampDisconnectModal;